import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './PurchaseCompleteAlert.module.scss';

interface Props {
  className?: string;
  labelType: string;
}

const PurchaseCompleteAlert = ({
  className,
  labelType,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseCompleteAlert, className);

  return (
    <div className={classes}>
      <span className={css.PurchaseCompleteAlert__Title}>
        {intl.formatMessage({
          id: `purchases.purchaseCompleteAlert.title.${labelType}`,
        })}
      </span>
      <span className={css.PurchaseCompleteAlert__Text}>
        {intl.formatMessage({
          id: `purchases.purchaseCompleteAlert.message1.${labelType}`,
        })}
      </span>
      <span className={css.PurchaseCompleteAlert__Text}>
        {intl.formatMessage({
          id: `purchases.purchaseCompleteAlert.message2.${labelType}`,
        })}
      </span>
    </div>
  );
};

export default injectIntl(PurchaseCompleteAlert);
